import api from './api';

export const uploadImage = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append('image', file);

  const response = await api.post('/uploads/images', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data.imageUrl;
};

export const getImageUrl = (imagePath: string | null | undefined): string => {
  if (!imagePath) {
    return '/images/default-placeholder.jpg';
  }

  // If it's already a full URL, return as is
  if (imagePath.startsWith('http')) {
    return imagePath;
  }

  // Otherwise, prepend the API base URL
  return `${process.env.REACT_APP_API_URL}/uploads/${imagePath}`;
}; 